import * as React from "react";

import { cn } from "@/utils/shadcn-ui";

function NativeSelect({
  className,
  children,
  ...props
}: React.ComponentProps<"select">) {
  return (
    <select
      data-slot="native-select"
      className={cn(
        "border-input placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 h-8 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-sm transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        // The native option popup defaults to the browser's light background;
        // give options an explicit themed bg/text so they stay readable in dark mode.
        "[&_option]:bg-popover [&_option]:text-popover-foreground",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        "focus-visible:aria-invalid:ring-ring/50 focus-visible:aria-invalid:border-ring",
        className,
      )}
      {...props}
    >
      {children}
    </select>
  );
}

export { NativeSelect };
